import { useQuery, useMutation } from '@tanstack/react-query'
import { settingsAPI } from '../../api'
import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import { RiLoader4Line, RiSaveLine } from 'react-icons/ri'
import toast from 'react-hot-toast'

export default function AdminSettings() {
  const { data: settings, isLoading } = useQuery({
    queryKey: ['admin-settings'],
    queryFn: () => settingsAPI.get(),
    select: (r) => r.data?.data,
  })

  const { register, handleSubmit, reset } = useForm()

  useEffect(() => { if (settings) reset(settings) }, [settings, reset])

  const mutation = useMutation({
    mutationFn: (data) => settingsAPI.update(data),
    onSuccess: () => toast.success('Settings saved'),
    onError: () => toast.error('Save failed'),
  })

  if (isLoading) return <div className="flex justify-center py-20"><RiLoader4Line className="animate-spin text-3xl text-salon-primary" /></div>

  return (
    <div className="space-y-6 max-w-2xl">
      <h2 className="font-display text-salon-dark text-2xl font-bold">Salon Settings</h2>

      <form onSubmit={handleSubmit((d) => mutation.mutate(d))} className="space-y-6">
        {/* General */}
        <div className="bg-white rounded-2xl border border-salon-cream-dark p-6 space-y-4">
          <h3 className="font-semibold font-body text-salon-dark">General Information</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="input-label">Salon Name</label><input {...register('salon_name')} className="input-field" /></div>
            <div><label className="input-label">Phone</label><input {...register('phone')} className="input-field" /></div>
            <div className="sm:col-span-2"><label className="input-label">Email</label><input {...register('email')} type="email" className="input-field" /></div>
            <div className="sm:col-span-2"><label className="input-label">Address</label><textarea {...register('address')} className="input-field resize-none min-h-[80px]" /></div>
          </div>
        </div>

        {/* Hours */}
        <div className="bg-white rounded-2xl border border-salon-cream-dark p-6 space-y-4">
          <h3 className="font-semibold font-body text-salon-dark">Working Hours</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="input-label">Opening Time</label><input {...register('opening_time')} type="time" className="input-field" /></div>
            <div><label className="input-label">Closing Time</label><input {...register('closing_time')} type="time" className="input-field" /></div>
            <div><label className="input-label">Slot Duration (min)</label><input {...register('slot_duration')} type="number" className="input-field" /></div>
            <div><label className="input-label">Advance Booking (days)</label><input {...register('advance_booking_days')} type="number" className="input-field" /></div>
          </div>
        </div>

        {/* Payment */}
        <div className="bg-white rounded-2xl border border-salon-cream-dark p-6 space-y-4">
          <h3 className="font-semibold font-body text-salon-dark">Payment Settings</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="input-label">Stripe Publishable Key</label><input {...register('stripe_key')} className="input-field" placeholder="pk_..." /></div>
            <div><label className="input-label">Currency</label>
              <select {...register('currency')} className="input-field">
                <option value="INR">INR – Indian Rupee</option>
                <option value="USD">USD – US Dollar</option>
                <option value="EUR">EUR – Euro</option>
              </select>
            </div>
          </div>
        </div>

        <button type="submit" disabled={mutation.isPending} className="btn-primary">
          {mutation.isPending ? <RiLoader4Line className="animate-spin" /> : <RiSaveLine />}
          Save Settings
        </button>
      </form>
    </div>
  )
}
